module.exports = __webpack_public_path__ + "static/media/CS131.ffb334e1.PNG";